import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

export const ASK_TO_UNRESTRICT_LEASING_MODAL_ID = 'AskToUnRestrictLeasing';

export const useAskToUnRestrictLeasingModalControls = () => useBrowserModalControls(ASK_TO_UNRESTRICT_LEASING_MODAL_ID);
